import { convertFormFieldType } from "../../utils";
import type { FormFieldNode } from "../../utils/types";

export interface IsNextDisabledArgs {
  activeField: FormFieldNode | undefined;
  fieldErrors: Record<string, string | null>;
  repeatMismatchFieldIds: Set<string>;
  isFieldValueValid: (fieldId: string) => boolean;
}

export const isNextDisabled = ({
  activeField,
  fieldErrors,
  repeatMismatchFieldIds,
  isFieldValueValid,
}: IsNextDisabledArgs): boolean => {
  if (!activeField) return true;
  if (activeField.value.options?.disableNext === true) return true;
  if (convertFormFieldType(activeField.value.type) === null) return false;
  if (repeatMismatchFieldIds.has(activeField.value.id)) return true;
  if (fieldErrors[activeField.value.id]) return true;

  // A group is gated even when marked optional: `isOptional` on the group itself says nothing about
  // its required sub-fields, and `resolveFieldValidity` answers for the group by checking those.
  // A signature likewise: consenting with no name is an invalid signature, not an empty answer, so
  // an optional one must still be gated once consent is given.
  if (
    activeField.value.type === "Question Group" ||
    activeField.value.type === "signature" ||
    !activeField.value.isOptional
  ) {
    if (!isFieldValueValid(activeField.value.id)) return true;
  }

  return false;
};
